// extracted by mini-css-extract-plugin
export default {"header":"AnnouncementPageFrame_header__Fwhm1","footer":"AnnouncementPageFrame_footer__BCviF"};